<div class="edf-loader-container {{customClass}}">
    <span class="edf-loader"></span>
</div>